(function() {
  var threshold = 6500;

  function updateBar(total) {
    var remaining = threshold - total;
    var percent = Math.min((total / threshold) * 100, 100);
    var fill = document.getElementById('free-shipping-fill');
    var message = document.getElementById('free-shipping-message');
    if (fill) fill.style.width = percent + '%';
    if (message) {
      if (remaining > 0) {
        var euros = Math.floor(remaining / 100);
        var cents = remaining % 100;
        message.textContent = '🚚 Nog €' + euros + ',' + (cents < 10 ? '0' : '') + cents + ' voor gratis verzending binnen Nederland bij bestellingen tot en met 10 kg';
      } else {
     message.textContent = '✅ Gratis verzending binnen Nederland vanaf €65 bij bestellingen tot en met 10 kg. Boven 10 kg worden verzendkosten berekend bij het afrekenen.';
      }
    }
  }

  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateBar(cart.total_price); })
      .catch(function() {});
  }

  fetchAndUpdate();

  // Dawn events
  document.addEventListener('cart:updated', fetchAndUpdate);
  document.addEventListener('cart:refresh', fetchAndUpdate);

  // Luister naar quantity-input changes op de cart pagina
  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList.contains('quantity__input')) {
      setTimeout(fetchAndUpdate, 500);
    }
  });

  // Polling als fallback
  setInterval(fetchAndUpdate, 2000);
})();